import { useLocale } from 'state/intl';

import { useLoyaltyActiveCard } from './loyalty';

enum BarCodeToCountry {
  '0463' = 'CA',
  '0464' = 'US'
}

export default () => {
  const { region } = useLocale();
  const { activeCard } = useLoyaltyActiveCard();

  return {
    isInSameRegion:
      activeCard &&
      activeCard.barcode &&
      BarCodeToCountry[activeCard.barcode.substr(0, 4)] === region,
    loyaltyRegion:
      activeCard && activeCard.barcode && BarCodeToCountry[activeCard.barcode.substr(0, 4)]
  };
};
